import * as React from "react";
import styled from "styled-components";
import { Switch, Route } from "react-router-dom";

import Home from "./Home";

const Container = styled.div.attrs({ className: "menu" })`
  background: ${props => props.theme.colors.shark};

  .menu__item {
    font-size: 16px;
    font-weight: 500;
    height: 56px;
    margin: 0 0 1px 0;
  }
  .menu__subitems {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s;
  }
  .menu__item.open .menu__subitems {
    max-height: 1000px;
  }

  .menu__link {
    background: ${props => props.theme.colors.mako};
    color: ${props => props.theme.colors.palesky};
    display: flex;
    height: 100%;
    padding: 20px 24px;
    text-decoration: none;
    width: 100%;
  }
  .menu__link.active {
    border-left: ${props => `4px solid ${props.theme.colors.solera}`};
  }
  .menu__link.active,
  .menu__link:hover {
    background: ${props => props.theme.colors.shark};
    color: ${props => props.theme.colors.white};
  }
  .menu__link.active .menu__icon {
    filter: brightness(200%);
  }

  .menu__icon {
    height: 16px;
    margin: 0 16px 0 0;
  }
  .menu__icon--collapse {
    position: absolute;
    right: 0;
    width: 16px;
  }

  .menu__subitem {
    background: ${props => props.theme.colors.shark};
    border-left: ${props => `4px solid ${props.theme.colors.shark}`};
    padding: 20px 24px 20px 52px;
    position: relative;
  }
  .menu__subitem::after {
    background: ${props => props.theme.colors.mako};
    bottom: 0;
    content: "";
    height: 1px;
    left: 54px;
    position: absolute;
    width: 24px;
  }
  .menu__subitem:last-of-type::after {
    content: none;
  }
`;

const MenuMain = () => {
  return (
    <Container>
      <Switch>
        <Route path="/" component={Home} />
      </Switch>
    </Container>
  );
};

export default MenuMain;
